function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';
var uuidv4 = require('uuid/v4');
import 'leaflet/dist/leaflet.css';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

var logdown = require('logdown');
var console = logdown('rx-forms-rx-map', { prefixColor: '#ffd740' });

var RXMap = function (_Component) {
  _inherits(RXMap, _Component);

  function RXMap(props) {
    _classCallCheck(this, RXMap);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.addMarker = function (e) {
      console.log('in add marker: ', e);
      var markers = _this.state.markers;

      _this.setState({
        markers: [e.latlng],
        latitude: e.latlng.lat,
        longitude: e.latlng.lng,
        draggable: true
      });
      _this.doOnChange(e.latlng.lat, e.latlng.lng);
    };

    _this.updatePosition = function (e) {
      var marker = _this.refmarker.current;

      _this.setState({
        markers: [marker.leafletElement.getLatLng()],
        latitude: marker.leafletElement.getLatLng().lat,
        longitude: marker.leafletElement.getLatLng().lng,
        draggable: true
      });
      _this.doOnChange(marker.leafletElement.getLatLng().lat, marker.leafletElement.getLatLng().lng);
    };

    _this.changeCoords = function (e, coord) {
      var _this$setState;

      _this.setState((_this$setState = {}, _this$setState[coord] = e.target.value, _this$setState));
    };

    _this.onCoordinatesBlur = function (e) {
      if (_this.state.latitude != "" && _this.state.longitude != "") {
        _this.setState(function (prevState) {
          return {
            markers: [L.latLng(prevState.latitude, prevState.longitude)]
          };
        });
        _this.doOnChange(_this.state.latitude, _this.state.longitude);
      }
    };

    _this.doOnChange = function (lat, lng) {
      _this.props.onChange({ target: { value: { lat: lat, lng: lng }, id: _this.props.name } });
    };

    console.log('13000: ', _this.props);

    _this.state = {
      invalid: false,
      position: _this.props.initialPosition ? _this.props.initialPosition : [40.071, 9.048],
      zoom: _this.props.initialZoom ? _this.props.initialZoom : 8,
      editor: "",
      height: _this.props.height ? _this.props.height : 400,
      draggable: false,
      markers: _this.props.value && _this.props.value.lat && _this.props.value.lng ? [L.latLng(_this.props.value.lat, _this.props.value.lng)] : [],
      latitude: _this.props.value && _this.props.value.lat ? _this.props.value.lat : "",
      longitude: _this.props.value && _this.props.value.lng ? _this.props.value.lng : ""
    };

    return _this;
  }

  RXMap.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {

    if (this.props.value != prevProps.value) {
      this.setState({
        markers: this.props.value && this.props.value.lat && this.props.value.lng ? [L.latLng(this.props.value.lat, this.props.value.lng)] : [],
        latitude: this.props.value && this.props.value.lat ? this.props.value.lat : "",
        longitude: this.props.value && this.props.value.lng ? this.props.value.lng : ""

      });
    }
  };

  RXMap.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      React.Fragment,
      null,
      React.createElement(
        'div',
        { style: { height: this.state.height, position: 'relative' } },
        React.createElement(
          Map,
          { center: this.state.position, zoom: this.state.zoom, style: { position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 }, onClick: this.addMarker },
          React.createElement(TileLayer, {
            url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
            attribution: '\xA9 <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          }),
          this.state.markers.map(function (value, index) {
            return React.createElement(Marker, {
              key: 'marker-' + index,
              position: value,
              draggable: false,
              onDragend: function onDragend(e) {
                return _this2.updatePosition(e, value);
              },
              ref: function ref(_ref) {
                return _this2.refMarker = _ref;
              }
            });
          })
        )
      ),
      React.createElement(
        Row,
        { style: { marginTop: 10 }, form: true },
        React.createElement(
          Col,
          { md: 6 },
          React.createElement(
            FormGroup,
            { row: true },
            React.createElement(
              Label,
              { sm: 3, 'for': 'lat' },
              'Latitude'
            ),
            React.createElement(
              Col,
              { sm: 9 },
              React.createElement(Input, { type: 'text', name: 'lat', onBlur: function onBlur(e) {
                  return _this2.onCoordinatesBlur(e);
                }, onChange: function onChange(e) {
                  return _this2.changeCoords(e, "latitude");
                }, value: this.state.latitude, placeholder: 'latitude' })
            )
          )
        ),
        React.createElement(
          Col,
          { md: 6 },
          React.createElement(
            FormGroup,
            { row: true },
            React.createElement(
              Label,
              { sm: 3, 'for': 'lng' },
              'Longitude'
            ),
            React.createElement(
              Col,
              { sm: 9 },
              React.createElement(Input, { type: 'text', name: 'lng', onBlur: function onBlur(e) {
                  return _this2.onCoordinatesBlur(e);
                }, onChange: function onChange(e) {
                  return _this2.changeCoords(e, "longitude");
                }, value: this.state.longitude, placeholder: 'longitude' })
            )
          )
        )
      )
    );
  };

  return RXMap;
}(Component);

export default RXMap;